(function () {
  if (window.__hemiQA) return; window.__hemiQA = true;
  function clearEmpty(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-empty');
    var inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
  }
  function openDrawer(res) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && res && res.sections) {
      try { drawer.renderContents(res); } catch (e) { window.location.href = '/cart'; return; }
      clearEmpty(drawer);
      if (typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
      document.body.classList.add('overflow-hidden');
      return;
    }
    if (res && res.sections && res.sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) { bubble.innerHTML = res.sections['cart-icon-bubble']; return; }
    }
    window.location.href = '/cart';
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-add]') : null;
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-add');
    if (!id) return;
    btn.classList.add('is-loading');
    var body = { items: [{ id: id, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname };
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (res && res.status && res.status !== 200) { return; }
        openDrawer(res);
      })
      .catch(function () { btn.classList.remove('is-loading'); window.location.href = '/cart'; });
  });
})();
